<template>
  <div class="page">
    <h2 class="title">STAI状态–特质焦虑问卷</h2>

    <div class="card">
      <div class="check-icon">✔️</div>
      <p class="complete-title">测评完成</p>
      <p class="complete-text">感谢您的参与！您的答卷已成功提交。</p>
      <button class="home-btn" @click="goHome">返回首页</button>
    </div>
  </div>
</template>

<script>
export default {
    methods: {
        goHome () {
            this.$router.push('/appraisal/state-anxiety');
        }
    }
};
</script>

<style scoped>
.page {
  background: #f4f8fa;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;
}
.title {
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 20px;
}
.card {
  background: white;
  border-radius: 12px;
  padding: 30px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  text-align: center;
}
.check-icon {
  font-size: 48px;
  color: #05C2CB;
  margin-bottom: 10px;
}
.complete-title {
  font-size: 18px;
  font-weight: bold;
  color: #05C2CB;
  margin-bottom: 8px;
}
.complete-text {
  font-size: 15px;
  color: #333;
  margin-bottom: 20px;
}
.home-btn {
  background-color: #05C2CB;
  color: white;
  border: none;
  padding: 10px 24px;
  font-size: 15px;
  border-radius: 12px;
  cursor: pointer;
}
.home-btn:hover {
  opacity: 0.9;
}
</style>
